module.exports = __webpack_public_path__ + "img/empty-office.9ca28468.svg";